export enum PaymentModeTypeEnum {
  COURIER_COD = 'COURIER_COD',
  COURIER_COD_CARD = 'COURIER_COD_CARD',
  COURIER_COD_CREDIT = 'COURIER_COD_CREDIT',
  COURIER_ONLINE = 'COURIER_ONLINE',
  POS_COD = 'POS_COD',
  POS_COD_CREDIT = 'POS_COD_CREDIT',
  EMAIL_COD = 'EMAIL_COD'
}
